import { PenRangeFilterForm } from "components/Filter/Form/PenRange/Component";
import {
  getPenRangeFilterSetting,
  getPenRangeFilterFormData,
  getPenRangeValidationSchema,
  getPenRangeFilterIsActive,
} from "components/Filter/Form/PenRange/processData";
import { FilterConf } from "components/Filter/types";

export const MlaPenRangeFilterConf: FilterConf = {
  filterForm: PenRangeFilterForm,
  filterFormExtraProps: {
    areEmptyPensVisible: true,
    forMlaTabs: true,
  },
  getFilterSetting: getPenRangeFilterSetting,
  id: "mla-pen-range",
  getFormData: getPenRangeFilterFormData,
  getIsActive: getPenRangeFilterIsActive,
  getValidationSchema: getPenRangeValidationSchema,
};
